import { IFilters } from 'types/VehicleFaults';

export const filtersToQueryStringConverter = (filters: IFilters) => {
	let queryString = '';

	for (const [key, value] of Object.entries(filters)) {
		if (Array.isArray(value) && value.some((item) => item.checked)) {
			let subQuery = `${key}=`;
			const separator = key === 'branch' ? '|' : ',';
			for (const filter of value) {
				if (filter.checked) {
					subQuery += `${encodeURIComponent(filter.title)}${separator}`;
				}
			}
			subQuery = subQuery.substring(0, subQuery.length - separator.length);
			queryString = queryString.concat(subQuery + '&');
		} else if (!Array.isArray(value) && value !== null && value.length > 0) {
			queryString = queryString.concat(
				`${key.toLocaleLowerCase()}=${encodeURIComponent(value)}&`
			);
		}
	}
	return queryString;
};
